import { ReactElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styles from '../ClientCreationForm.module.scss';
import { Input, MaskInput, Typography } from '../../../../1_shared/ui';
import { phoneFormConvert } from '../../../../1_shared/lib/helpers/phoneConvert';
import { TClientCreationForm } from '../../model/ClientCreationFormSchema';

const FormFields = (): ReactElement => {
  const {
    control,
    formState: { errors },
  } = useFormContext<TClientCreationForm>();

  return (
    <>
      <Controller
        control={control}
        name="nickname"
        render={({ field }) => (
          <div className={styles.fieldContainer}>
            <Input
              rootClassName={styles.inputStyle}
              {...field}
              label="Имя или псевдоним"
            />
            {errors.nickname && (
              <Typography type="description" className={styles.error}>
                {errors.nickname?.message}
              </Typography>
            )}
          </div>
        )}
      />
      <Controller
        control={control}
        name="phone"
        render={({ field }) => (
          <div className={styles.fieldContainer}>
            <MaskInput
              {...field}
              autocomplete="on"
              onChange={e => {
                const maskPhone = phoneFormConvert(e.target.value);
                field.onChange(maskPhone);
              }}
              label="Телефон"
              mask="+79999999999"
            />
            {errors.phone && (
              <Typography type="description" className={styles.error}>
                {errors?.phone?.message}
              </Typography>
            )}
          </div>
        )}
      />
      <Controller
        control={control}
        name="email"
        render={({ field }) => (
          <div className={styles.fieldContainer}>
            <Input rootClassName={styles.inputStyle} {...field} label="Email" />
            {errors.email && (
              <Typography type="description" className={styles.error}>
                {errors.email?.message}
              </Typography>
            )}
          </div>
        )}
      />
    </>
  );
};

export default FormFields;
